import { defineComponent as e, h as r } from "vue";
import n from "./novoui-vuejs575.js";
import a from "./novoui-vuejs576.js";
import t from "./novoui-vuejs577.js";
import u from "./novoui-vuejs578.js";
import m from "./novoui-vuejs579.js";
import s from "./novoui-vuejs580.js";
import o from "./novoui-vuejs581.js";
import i from "./novoui-vuejs582.js";
import p from "./novoui-vuejs583.js";
import l from "./novoui-vuejs584.js";
import f from "./novoui-vuejs585.js";
import d from "./novoui-vuejs586.js";
import c from "./novoui-vuejs587.js";
import g from "./novoui-vuejs588.js";
import b from "./novoui-vuejs589.js";
import A from "./novoui-vuejs590.js";
import h from "./novoui-vuejs591.js";
import M from "./novoui-vuejs592.js";
import R from "./novoui-vuejs593.js";
import I from "./novoui-vuejs594.js";
import S from "./novoui-vuejs595.js";
import N from "./novoui-vuejs596.js";
import T from "./novoui-vuejs597.js";
import G from "./novoui-vuejs598.js";
import L from "./novoui-vuejs599.js";
import B from "./novoui-vuejs600.js";
import y from "./novoui-vuejs601.js";
import C from "./novoui-vuejs602.js";
import E from "./novoui-vuejs603.js";
import K from "./novoui-vuejs604.js";
import k from "./novoui-vuejs605.js";
import U from "./novoui-vuejs606.js";
import v from "./novoui-vuejs607.js";
import O from "./novoui-vuejs608.js";
import P from "./novoui-vuejs609.js";
import D from "./novoui-vuejs610.js";
import w from "./novoui-vuejs611.js";
import z from "./novoui-vuejs612.js";
import H from "./novoui-vuejs613.js";
import V from "./novoui-vuejs614.js";
import F from "./novoui-vuejs615.js";
import Z from "./novoui-vuejs616.js";
import Y from "./novoui-vuejs617.js";
import W from "./novoui-vuejs618.js";
import j from "./novoui-vuejs619.js";
import J from "./novoui-vuejs620.js";
import q from "./novoui-vuejs621.js";
import Q from "./novoui-vuejs622.js";
import x from "./novoui-vuejs623.js";
import X from "./novoui-vuejs624.js";
import _ from "./novoui-vuejs625.js";
import $ from "./novoui-vuejs626.js";
import ee from "./novoui-vuejs627.js";
import re from "./novoui-vuejs628.js";
import ne from "./novoui-vuejs629.js";
import ae from "./novoui-vuejs630.js";
import te from "./novoui-vuejs631.js";
import ue from "./novoui-vuejs632.js";
import me from "./novoui-vuejs633.js";
import se from "./novoui-vuejs634.js";
import oe from "./novoui-vuejs635.js";
import ie from "./novoui-vuejs636.js";
import pe from "./novoui-vuejs637.js";
import le from "./novoui-vuejs638.js";
import fe from "./novoui-vuejs639.js";
import de from "./novoui-vuejs640.js";
import ce from "./novoui-vuejs641.js";
import ge from "./novoui-vuejs642.js";
import be from "./novoui-vuejs643.js";
import Ae from "./novoui-vuejs644.js";
import he from "./novoui-vuejs645.js";
import Me from "./novoui-vuejs646.js";
import Re from "./novoui-vuejs647.js";
import Ie from "./novoui-vuejs648.js";
import Se from "./novoui-vuejs649.js";
import Ne from "./novoui-vuejs650.js";
import Te from "./novoui-vuejs651.js";
import Ge from "./novoui-vuejs652.js";
import Le from "./novoui-vuejs653.js";
import Be from "./novoui-vuejs654.js";
import ye from "./novoui-vuejs655.js";
import Ce from "./novoui-vuejs656.js";
import Ee from "./novoui-vuejs657.js";
import Ke from "./novoui-vuejs658.js";
import ke from "./novoui-vuejs659.js";
import Ue from "./novoui-vuejs660.js";
import ve from "./novoui-vuejs661.js";
import Oe from "./novoui-vuejs662.js";
import Pe from "./novoui-vuejs663.js";
import De from "./novoui-vuejs664.js";
import we from "./novoui-vuejs665.js";
import ze from "./novoui-vuejs666.js";
import He from "./novoui-vuejs667.js";
import Ve from "./novoui-vuejs668.js";
import Fe from "./novoui-vuejs669.js";
import Ze from "./novoui-vuejs670.js";
import Ye from "./novoui-vuejs671.js";
import We from "./novoui-vuejs672.js";
import je from "./novoui-vuejs673.js";
import Je from "./novoui-vuejs674.js";
import qe from "./novoui-vuejs675.js";
import Qe from "./novoui-vuejs676.js";
import xe from "./novoui-vuejs677.js";
import Xe from "./novoui-vuejs678.js";
import _e from "./novoui-vuejs679.js";
import $e from "./novoui-vuejs680.js";
import er from "./novoui-vuejs681.js";
import rr from "./novoui-vuejs682.js";
import nr from "./novoui-vuejs683.js";
import ar from "./novoui-vuejs684.js";
import tr from "./novoui-vuejs685.js";
import ur from "./novoui-vuejs686.js";
import mr from "./novoui-vuejs687.js";
import sr from "./novoui-vuejs688.js";
import or from "./novoui-vuejs689.js";
import ir from "./novoui-vuejs690.js";
import pr from "./novoui-vuejs691.js";
import lr from "./novoui-vuejs692.js";
import fr from "./novoui-vuejs693.js";
import dr from "./novoui-vuejs694.js";
import cr from "./novoui-vuejs695.js";
import gr from "./novoui-vuejs696.js";
import br from "./novoui-vuejs697.js";
import Ar from "./novoui-vuejs698.js";
import hr from "./novoui-vuejs699.js";
import Mr from "./novoui-vuejs700.js";
import Rr from "./novoui-vuejs701.js";
import Ir from "./novoui-vuejs702.js";
import Sr from "./novoui-vuejs703.js";
import Nr from "./novoui-vuejs704.js";
import Tr from "./novoui-vuejs705.js";
import Gr from "./novoui-vuejs706.js";
import Lr from "./novoui-vuejs707.js";
import Br from "./novoui-vuejs708.js";
import yr from "./novoui-vuejs709.js";
import Cr from "./novoui-vuejs710.js";
import Er from "./novoui-vuejs711.js";
import Kr from "./novoui-vuejs712.js";
import kr from "./novoui-vuejs713.js";
import Ur from "./novoui-vuejs714.js";
import vr from "./novoui-vuejs715.js";
import Or from "./novoui-vuejs716.js";
import Pr from "./novoui-vuejs717.js";
import Dr from "./novoui-vuejs718.js";
import wr from "./novoui-vuejs719.js";
import zr from "./novoui-vuejs720.js";
import Hr from "./novoui-vuejs721.js";
import Vr from "./novoui-vuejs722.js";
import Fr from "./novoui-vuejs723.js";
import Zr from "./novoui-vuejs724.js";
import Yr from "./novoui-vuejs725.js";
import Wr from "./novoui-vuejs726.js";
import jr from "./novoui-vuejs727.js";
import Jr from "./novoui-vuejs728.js";
import qr from "./novoui-vuejs729.js";
import Qr from "./novoui-vuejs730.js";
import xr from "./novoui-vuejs731.js";
import Xr from "./novoui-vuejs732.js";
import _r from "./novoui-vuejs733.js";
import $r from "./novoui-vuejs734.js";
import en from "./novoui-vuejs735.js";
import rn from "./novoui-vuejs736.js";
import nn from "./novoui-vuejs737.js";
import an from "./novoui-vuejs738.js";
import tn from "./novoui-vuejs739.js";
import un from "./novoui-vuejs740.js";
import mn from "./novoui-vuejs741.js";
import sn from "./novoui-vuejs742.js";
import on from "./novoui-vuejs743.js";
import pn from "./novoui-vuejs744.js";
import ln from "./novoui-vuejs745.js";
import fn from "./novoui-vuejs746.js";
import dn from "./novoui-vuejs747.js";
import cn from "./novoui-vuejs748.js";
import gn from "./novoui-vuejs749.js";
import bn from "./novoui-vuejs750.js";
import An from "./novoui-vuejs751.js";
import hn from "./novoui-vuejs752.js";
import Mn from "./novoui-vuejs753.js";
import Rn from "./novoui-vuejs754.js";
import In from "./novoui-vuejs755.js";
import Sn from "./novoui-vuejs756.js";
import Nn from "./novoui-vuejs757.js";
import Tn from "./novoui-vuejs758.js";
import Gn from "./novoui-vuejs759.js";
import Ln from "./novoui-vuejs760.js";
import Bn from "./novoui-vuejs761.js";
import yn from "./novoui-vuejs762.js";
import Cn from "./novoui-vuejs763.js";
import En from "./novoui-vuejs764.js";
import Kn from "./novoui-vuejs765.js";
import kn from "./novoui-vuejs766.js";
import Un from "./novoui-vuejs767.js";
import vn from "./novoui-vuejs768.js";
import On from "./novoui-vuejs769.js";
import Pn from "./novoui-vuejs770.js";
import Dn from "./novoui-vuejs771.js";
import wn from "./novoui-vuejs772.js";
import zn from "./novoui-vuejs773.js";
import Hn from "./novoui-vuejs774.js";
import Vn from "./novoui-vuejs775.js";
import Fn from "./novoui-vuejs776.js";
import Zn from "./novoui-vuejs777.js";
import Yn from "./novoui-vuejs778.js";
import Wn from "./novoui-vuejs779.js";
import jn from "./novoui-vuejs780.js";
import Jn from "./novoui-vuejs781.js";
import qn from "./novoui-vuejs782.js";
import Qn from "./novoui-vuejs783.js";
import xn from "./novoui-vuejs784.js";
import Xn from "./novoui-vuejs785.js";
import _n from "./novoui-vuejs786.js";
import $n from "./novoui-vuejs787.js";
import ea from "./novoui-vuejs788.js";
import ra from "./novoui-vuejs789.js";
import na from "./novoui-vuejs790.js";
import aa from "./novoui-vuejs791.js";
import ta from "./novoui-vuejs792.js";
import ua from "./novoui-vuejs793.js";
import ma from "./novoui-vuejs794.js";
import sa from "./novoui-vuejs795.js";
import oa from "./novoui-vuejs796.js";
import ia from "./novoui-vuejs797.js";
import pa from "./novoui-vuejs798.js";
import la from "./novoui-vuejs799.js";
import fa from "./novoui-vuejs800.js";
import da from "./novoui-vuejs801.js";
import ca from "./novoui-vuejs802.js";
import ga from "./novoui-vuejs803.js";
import ba from "./novoui-vuejs804.js";
import Aa from "./novoui-vuejs805.js";
import ha from "./novoui-vuejs806.js";
import Ma from "./novoui-vuejs807.js";
import Ra from "./novoui-vuejs808.js";
import Ia from "./novoui-vuejs809.js";
import Sa from "./novoui-vuejs810.js";
import Na from "./novoui-vuejs811.js";
import Ta from "./novoui-vuejs812.js";
import Ga from "./novoui-vuejs813.js";
import La from "./novoui-vuejs814.js";
import Ba from "./novoui-vuejs815.js";
const eo = { aalandIslands: e({ name: "aalandIslands", setup() {
  return () => r(n);
} }), ALA: e({ name: "ALA", setup() {
  return () => r(n);
} }), afghanistan: e({ name: "afghanistan", setup() {
  return () => r(a);
} }), AFG: e({ name: "AFG", setup() {
  return () => r(a);
} }), albania: e({ name: "albania", setup() {
  return () => r(t);
} }), ALB: e({ name: "ALB", setup() {
  return () => r(t);
} }), algeria: e({ name: "algeria", setup() {
  return () => r(u);
} }), DZA: e({ name: "DZA", setup() {
  return () => r(u);
} }), americanSamoa: e({ name: "americanSamoa", setup() {
  return () => r(m);
} }), ASM: e({ name: "ASM", setup() {
  return () => r(m);
} }), andorra: e({ name: "andorra", setup() {
  return () => r(s);
} }), AND: e({ name: "AND", setup() {
  return () => r(s);
} }), angola: e({ name: "angola", setup() {
  return () => r(o);
} }), AGO: e({ name: "AGO", setup() {
  return () => r(o);
} }), anguilla: e({ name: "anguilla", setup() {
  return () => r(i);
} }), AIA: e({ name: "AIA", setup() {
  return () => r(i);
} }), antiguaAndBarbuda: e({ name: "antiguaAndBarbuda", setup() {
  return () => r(p);
} }), ATG: e({ name: "ATG", setup() {
  return () => r(p);
} }), argentina: e({ name: "argentina", setup() {
  return () => r(l);
} }), ARG: e({ name: "ARG", setup() {
  return () => r(l);
} }), armenia: e({ name: "armenia", setup() {
  return () => r(f);
} }), ARM: e({ name: "ARM", setup() {
  return () => r(f);
} }), aruba: e({ name: "aruba", setup() {
  return () => r(d);
} }), ABW: e({ name: "ABW", setup() {
  return () => r(d);
} }), australia: e({ name: "australia", setup() {
  return () => r(c);
} }), AUS: e({ name: "AUS", setup() {
  return () => r(c);
} }), austria: e({ name: "austria", setup() {
  return () => r(g);
} }), AUT: e({ name: "AUT", setup() {
  return () => r(g);
} }), azerbaijan: e({ name: "azerbaijan", setup() {
  return () => r(b);
} }), AZE: e({ name: "AZE", setup() {
  return () => r(b);
} }), bahamas: e({ name: "bahamas", setup() {
  return () => r(A);
} }), BHS: e({ name: "BHS", setup() {
  return () => r(A);
} }), bahrain: e({ name: "bahrain", setup() {
  return () => r(h);
} }), BHR: e({ name: "BHR", setup() {
  return () => r(h);
} }), bangladesh: e({ name: "bangladesh", setup() {
  return () => r(M);
} }), BGD: e({ name: "BGD", setup() {
  return () => r(M);
} }), barbados: e({ name: "barbados", setup() {
  return () => r(R);
} }), BRB: e({ name: "BRB", setup() {
  return () => r(R);
} }), belarus: e({ name: "belarus", setup() {
  return () => r(I);
} }), BLR: e({ name: "BLR", setup() {
  return () => r(I);
} }), belgium: e({ name: "belgium", setup() {
  return () => r(S);
} }), BEL: e({ name: "BEL", setup() {
  return () => r(S);
} }), belize: e({ name: "belize", setup() {
  return () => r(N);
} }), BLZ: e({ name: "BLZ", setup() {
  return () => r(N);
} }), benin: e({ name: "benin", setup() {
  return () => r(T);
} }), BEN: e({ name: "BEN", setup() {
  return () => r(T);
} }), bermuda: e({ name: "bermuda", setup() {
  return () => r(G);
} }), BMU: e({ name: "BMU", setup() {
  return () => r(G);
} }), bhutan: e({ name: "bhutan", setup() {
  return () => r(L);
} }), BTN: e({ name: "BTN", setup() {
  return () => r(L);
} }), bolivia: e({ name: "bolivia", setup() {
  return () => r(B);
} }), BOL: e({ name: "BOL", setup() {
  return () => r(B);
} }), bonaireSintEustatiusAndSaba: e({ name: "bonaireSintEustatiusAndSaba", setup() {
  return () => r(y);
} }), BES: e({ name: "BES", setup() {
  return () => r(y);
} }), bosniaAndHerzegovina: e({ name: "bosniaAndHerzegovina", setup() {
  return () => r(C);
} }), BIH: e({ name: "BIH", setup() {
  return () => r(C);
} }), botswana: e({ name: "botswana", setup() {
  return () => r(E);
} }), BWA: e({ name: "BWA", setup() {
  return () => r(E);
} }), bouvetIsland: e({ name: "bouvetIsland", setup() {
  return () => r(K);
} }), BVT: e({ name: "BVT", setup() {
  return () => r(K);
} }), brazil: e({ name: "brazil", setup() {
  return () => r(k);
} }), BRA: e({ name: "BRA", setup() {
  return () => r(k);
} }), britishIndianOceanTerritory: e({ name: "britishIndianOceanTerritory", setup() {
  return () => r(U);
} }), IOT: e({ name: "IOT", setup() {
  return () => r(U);
} }), brunei: e({ name: "brunei", setup() {
  return () => r(v);
} }), BRN: e({ name: "BRN", setup() {
  return () => r(v);
} }), bulgaria: e({ name: "bulgaria", setup() {
  return () => r(O);
} }), BGR: e({ name: "BGR", setup() {
  return () => r(O);
} }), burkinaFaso: e({ name: "burkinaFaso", setup() {
  return () => r(P);
} }), BFA: e({ name: "BFA", setup() {
  return () => r(P);
} }), burundi: e({ name: "burundi", setup() {
  return () => r(D);
} }), BDI: e({ name: "BDI", setup() {
  return () => r(D);
} }), cambodia: e({ name: "cambodia", setup() {
  return () => r(w);
} }), KHM: e({ name: "KHM", setup() {
  return () => r(w);
} }), cameroon: e({ name: "cameroon", setup() {
  return () => r(z);
} }), CMR: e({ name: "CMR", setup() {
  return () => r(z);
} }), canada: e({ name: "canada", setup() {
  return () => r(H);
} }), CAN: e({ name: "CAN", setup() {
  return () => r(H);
} }), capeVerde: e({ name: "capeVerde", setup() {
  return () => r(V);
} }), CPV: e({ name: "CPV", setup() {
  return () => r(V);
} }), caymanIslands: e({ name: "caymanIslands", setup() {
  return () => r(F);
} }), CYM: e({ name: "CYM", setup() {
  return () => r(F);
} }), centralAfricanRepublic: e({ name: "centralAfricanRepublic", setup() {
  return () => r(Z);
} }), CAF: e({ name: "CAF", setup() {
  return () => r(Z);
} }), chad: e({ name: "chad", setup() {
  return () => r(Y);
} }), TCD: e({ name: "TCD", setup() {
  return () => r(Y);
} }), chile: e({ name: "chile", setup() {
  return () => r(W);
} }), CHL: e({ name: "CHL", setup() {
  return () => r(W);
} }), china: e({ name: "china", setup() {
  return () => r(j);
} }), CHN: e({ name: "CHN", setup() {
  return () => r(j);
} }), christmasIsland: e({ name: "christmasIsland", setup() {
  return () => r(J);
} }), CXR: e({ name: "CXR", setup() {
  return () => r(J);
} }), cocosKeelingIslands: e({ name: "cocosKeelingIslands", setup() {
  return () => r(q);
} }), CCK: e({ name: "CCK", setup() {
  return () => r(q);
} }), colombia: e({ name: "colombia", setup() {
  return () => r(Q);
} }), COL: e({ name: "COL", setup() {
  return () => r(Q);
} }), comoros: e({ name: "comoros", setup() {
  return () => r(x);
} }), COM: e({ name: "COM", setup() {
  return () => r(x);
} }), congoTheDemocraticRepublic: e({ name: "congoTheDemocraticRepublic", setup() {
  return () => r(X);
} }), COD: e({ name: "COD", setup() {
  return () => r(X);
} }), congo: e({ name: "congo", setup() {
  return () => r(_);
} }), COG: e({ name: "COG", setup() {
  return () => r(_);
} }), cookIslands: e({ name: "cookIslands", setup() {
  return () => r($);
} }), COK: e({ name: "COK", setup() {
  return () => r($);
} }), costaRica: e({ name: "costaRica", setup() {
  return () => r(ee);
} }), CRI: e({ name: "CRI", setup() {
  return () => r(ee);
} }), croatia: e({ name: "croatia", setup() {
  return () => r(re);
} }), HRV: e({ name: "HRV", setup() {
  return () => r(re);
} }), cuba: e({ name: "cuba", setup() {
  return () => r(ne);
} }), CUB: e({ name: "CUB", setup() {
  return () => r(ne);
} }), curacao: e({ name: "curacao", setup() {
  return () => r(ae);
} }), CUW: e({ name: "CUW", setup() {
  return () => r(ae);
} }), cyprus: e({ name: "cyprus", setup() {
  return () => r(te);
} }), CYP: e({ name: "CYP", setup() {
  return () => r(te);
} }), czechRepublic: e({ name: "czechRepublic", setup() {
  return () => r(ue);
} }), CZE: e({ name: "CZE", setup() {
  return () => r(ue);
} }), denmark: e({ name: "denmark", setup() {
  return () => r(me);
} }), DNK: e({ name: "DNK", setup() {
  return () => r(me);
} }), djibouti: e({ name: "djibouti", setup() {
  return () => r(se);
} }), DJI: e({ name: "DJI", setup() {
  return () => r(se);
} }), dominicanRepublic: e({ name: "dominicanRepublic", setup() {
  return () => r(oe);
} }), DOM: e({ name: "DOM", setup() {
  return () => r(oe);
} }), dominica: e({ name: "dominica", setup() {
  return () => r(ie);
} }), DMA: e({ name: "DMA", setup() {
  return () => r(ie);
} }), ecuador: e({ name: "ecuador", setup() {
  return () => r(pe);
} }), ECU: e({ name: "ECU", setup() {
  return () => r(pe);
} }), egypt: e({ name: "egypt", setup() {
  return () => r(le);
} }), EGY: e({ name: "EGY", setup() {
  return () => r(le);
} }), elSalvador: e({ name: "elSalvador", setup() {
  return () => r(fe);
} }), SLV: e({ name: "SLV", setup() {
  return () => r(fe);
} }), equatorialGuinea: e({ name: "equatorialGuinea", setup() {
  return () => r(de);
} }), GNQ: e({ name: "GNQ", setup() {
  return () => r(de);
} }), eritrea: e({ name: "eritrea", setup() {
  return () => r(ce);
} }), ERI: e({ name: "ERI", setup() {
  return () => r(ce);
} }), estonia: e({ name: "estonia", setup() {
  return () => r(ge);
} }), EST: e({ name: "EST", setup() {
  return () => r(ge);
} }), ethiopia: e({ name: "ethiopia", setup() {
  return () => r(be);
} }), ETH: e({ name: "ETH", setup() {
  return () => r(be);
} }), falklandIslandsMalvinas: e({ name: "falklandIslandsMalvinas", setup() {
  return () => r(Ae);
} }), FLK: e({ name: "FLK", setup() {
  return () => r(Ae);
} }), faroeIslands: e({ name: "faroeIslands", setup() {
  return () => r(he);
} }), FRO: e({ name: "FRO", setup() {
  return () => r(he);
} }), fiji: e({ name: "fiji", setup() {
  return () => r(Me);
} }), FJI: e({ name: "FJI", setup() {
  return () => r(Me);
} }), finland: e({ name: "finland", setup() {
  return () => r(Re);
} }), FIN: e({ name: "FIN", setup() {
  return () => r(Re);
} }), france: e({ name: "france", setup() {
  return () => r(Ie);
} }), FRA: e({ name: "FRA", setup() {
  return () => r(Ie);
} }), frenchGuiana: e({ name: "frenchGuiana", setup() {
  return () => r(Se);
} }), GUF: e({ name: "GUF", setup() {
  return () => r(Se);
} }), frenchPolynesia: e({ name: "frenchPolynesia", setup() {
  return () => r(Ne);
} }), PYF: e({ name: "PYF", setup() {
  return () => r(Ne);
} }), gabon: e({ name: "gabon", setup() {
  return () => r(Te);
} }), GAB: e({ name: "GAB", setup() {
  return () => r(Te);
} }), gambia: e({ name: "gambia", setup() {
  return () => r(Ge);
} }), GMB: e({ name: "GMB", setup() {
  return () => r(Ge);
} }), georgia: e({ name: "georgia", setup() {
  return () => r(Le);
} }), GEO: e({ name: "GEO", setup() {
  return () => r(Le);
} }), germany: e({ name: "germany", setup() {
  return () => r(Be);
} }), DEU: e({ name: "DEU", setup() {
  return () => r(Be);
} }), ghana: e({ name: "ghana", setup() {
  return () => r(ye);
} }), GHA: e({ name: "GHA", setup() {
  return () => r(ye);
} }), gibraltar: e({ name: "gibraltar", setup() {
  return () => r(Ce);
} }), GIB: e({ name: "GIB", setup() {
  return () => r(Ce);
} }), greece: e({ name: "greece", setup() {
  return () => r(Ee);
} }), GRC: e({ name: "GRC", setup() {
  return () => r(Ee);
} }), greenland: e({ name: "greenland", setup() {
  return () => r(Ke);
} }), GRL: e({ name: "GRL", setup() {
  return () => r(Ke);
} }), grenada: e({ name: "grenada", setup() {
  return () => r(ke);
} }), GRD: e({ name: "GRD", setup() {
  return () => r(ke);
} }), guadaloupe: e({ name: "guadaloupe", setup() {
  return () => r(Ue);
} }), GLP: e({ name: "GLP", setup() {
  return () => r(Ue);
} }), guam: e({ name: "guam", setup() {
  return () => r(ve);
} }), GUM: e({ name: "GUM", setup() {
  return () => r(ve);
} }), guatemala: e({ name: "guatemala", setup() {
  return () => r(Oe);
} }), GTM: e({ name: "GTM", setup() {
  return () => r(Oe);
} }), guernsey: e({ name: "guernsey", setup() {
  return () => r(Pe);
} }), GGY: e({ name: "GGY", setup() {
  return () => r(Pe);
} }), guineaBissau: e({ name: "guineaBissau", setup() {
  return () => r(De);
} }), GNB: e({ name: "GNB", setup() {
  return () => r(De);
} }), guinea: e({ name: "guinea", setup() {
  return () => r(we);
} }), GIN: e({ name: "GIN", setup() {
  return () => r(we);
} }), guyana: e({ name: "guyana", setup() {
  return () => r(ze);
} }), GUY: e({ name: "GUY", setup() {
  return () => r(ze);
} }), haiti: e({ name: "haiti", setup() {
  return () => r(He);
} }), HTI: e({ name: "HTI", setup() {
  return () => r(He);
} }), heardIslandsAndMcdonaldIslands: e({ name: "heardIslandsAndMcdonaldIslands", setup() {
  return () => r(Ve);
} }), HMD: e({ name: "HMD", setup() {
  return () => r(Ve);
} }), honduras: e({ name: "honduras", setup() {
  return () => r(Fe);
} }), HND: e({ name: "HND", setup() {
  return () => r(Fe);
} }), hongKong: e({ name: "hongKong", setup() {
  return () => r(Ze);
} }), HKG: e({ name: "HKG", setup() {
  return () => r(Ze);
} }), hungary: e({ name: "hungary", setup() {
  return () => r(Ye);
} }), HUN: e({ name: "HUN", setup() {
  return () => r(Ye);
} }), iceland: e({ name: "iceland", setup() {
  return () => r(We);
} }), ISL: e({ name: "ISL", setup() {
  return () => r(We);
} }), india: e({ name: "india", setup() {
  return () => r(je);
} }), IND: e({ name: "IND", setup() {
  return () => r(je);
} }), indonesia: e({ name: "indonesia", setup() {
  return () => r(Je);
} }), IDN: e({ name: "IDN", setup() {
  return () => r(Je);
} }), iran: e({ name: "iran", setup() {
  return () => r(qe);
} }), IRN: e({ name: "IRN", setup() {
  return () => r(qe);
} }), iraq: e({ name: "iraq", setup() {
  return () => r(Qe);
} }), IRQ: e({ name: "IRQ", setup() {
  return () => r(Qe);
} }), ireland: e({ name: "ireland", setup() {
  return () => r(xe);
} }), IRL: e({ name: "IRL", setup() {
  return () => r(xe);
} }), isleOfMan: e({ name: "isleOfMan", setup() {
  return () => r(Xe);
} }), IMN: e({ name: "IMN", setup() {
  return () => r(Xe);
} }), israel: e({ name: "israel", setup() {
  return () => r(_e);
} }), ISR: e({ name: "ISR", setup() {
  return () => r(_e);
} }), italy: e({ name: "italy", setup() {
  return () => r($e);
} }), ITA: e({ name: "ITA", setup() {
  return () => r($e);
} }), ivoryCoast: e({ name: "ivoryCoast", setup() {
  return () => r(er);
} }), CIV: e({ name: "CIV", setup() {
  return () => r(er);
} }), jamaica: e({ name: "jamaica", setup() {
  return () => r(rr);
} }), JAM: e({ name: "JAM", setup() {
  return () => r(rr);
} }), japan: e({ name: "japan", setup() {
  return () => r(nr);
} }), JPN: e({ name: "JPN", setup() {
  return () => r(nr);
} }), jersey: e({ name: "jersey", setup() {
  return () => r(ar);
} }), JEY: e({ name: "JEY", setup() {
  return () => r(ar);
} }), jordan: e({ name: "jordan", setup() {
  return () => r(tr);
} }), JOR: e({ name: "JOR", setup() {
  return () => r(tr);
} }), kazakhstan: e({ name: "kazakhstan", setup() {
  return () => r(ur);
} }), KAZ: e({ name: "KAZ", setup() {
  return () => r(ur);
} }), kenya: e({ name: "kenya", setup() {
  return () => r(mr);
} }), KEN: e({ name: "KEN", setup() {
  return () => r(mr);
} }), kiribati: e({ name: "kiribati", setup() {
  return () => r(sr);
} }), KIR: e({ name: "KIR", setup() {
  return () => r(sr);
} }), kuwait: e({ name: "kuwait", setup() {
  return () => r(or);
} }), KWT: e({ name: "KWT", setup() {
  return () => r(or);
} }), kyrgyzstan: e({ name: "kyrgyzstan", setup() {
  return () => r(ir);
} }), KGZ: e({ name: "KGZ", setup() {
  return () => r(ir);
} }), laos: e({ name: "laos", setup() {
  return () => r(pr);
} }), LAO: e({ name: "LAO", setup() {
  return () => r(pr);
} }), latvia: e({ name: "latvia", setup() {
  return () => r(lr);
} }), LVA: e({ name: "LVA", setup() {
  return () => r(lr);
} }), lebanon: e({ name: "lebanon", setup() {
  return () => r(fr);
} }), LBN: e({ name: "LBN", setup() {
  return () => r(fr);
} }), lesotho: e({ name: "lesotho", setup() {
  return () => r(dr);
} }), LSO: e({ name: "LSO", setup() {
  return () => r(dr);
} }), liberia: e({ name: "liberia", setup() {
  return () => r(cr);
} }), LBR: e({ name: "LBR", setup() {
  return () => r(cr);
} }), libya: e({ name: "libya", setup() {
  return () => r(gr);
} }), LBY: e({ name: "LBY", setup() {
  return () => r(gr);
} }), liechtenstein: e({ name: "liechtenstein", setup() {
  return () => r(br);
} }), LIE: e({ name: "LIE", setup() {
  return () => r(br);
} }), lithuania: e({ name: "lithuania", setup() {
  return () => r(Ar);
} }), LTU: e({ name: "LTU", setup() {
  return () => r(Ar);
} }), luxembourg: e({ name: "luxembourg", setup() {
  return () => r(hr);
} }), LUX: e({ name: "LUX", setup() {
  return () => r(hr);
} }), macao: e({ name: "macao", setup() {
  return () => r(Mr);
} }), MAC: e({ name: "MAC", setup() {
  return () => r(Mr);
} }), madagascar: e({ name: "madagascar", setup() {
  return () => r(Rr);
} }), MDG: e({ name: "MDG", setup() {
  return () => r(Rr);
} }), malawi: e({ name: "malawi", setup() {
  return () => r(Ir);
} }), MWI: e({ name: "MWI", setup() {
  return () => r(Ir);
} }), malaysia: e({ name: "malaysia", setup() {
  return () => r(Sr);
} }), MYS: e({ name: "MYS", setup() {
  return () => r(Sr);
} }), maldives: e({ name: "maldives", setup() {
  return () => r(Nr);
} }), MDV: e({ name: "MDV", setup() {
  return () => r(Nr);
} }), mali: e({ name: "mali", setup() {
  return () => r(Tr);
} }), MLI: e({ name: "MLI", setup() {
  return () => r(Tr);
} }), malta: e({ name: "malta", setup() {
  return () => r(Gr);
} }), MLT: e({ name: "MLT", setup() {
  return () => r(Gr);
} }), marshallIsland: e({ name: "marshallIsland", setup() {
  return () => r(Lr);
} }), MHL: e({ name: "MHL", setup() {
  return () => r(Lr);
} }), martinique: e({ name: "martinique", setup() {
  return () => r(Br);
} }), MTQ: e({ name: "MTQ", setup() {
  return () => r(Br);
} }), mauritania: e({ name: "mauritania", setup() {
  return () => r(yr);
} }), MRT: e({ name: "MRT", setup() {
  return () => r(yr);
} }), mauritius: e({ name: "mauritius", setup() {
  return () => r(Cr);
} }), MUS: e({ name: "MUS", setup() {
  return () => r(Cr);
} }), mayotte: e({ name: "mayotte", setup() {
  return () => r(Er);
} }), MYT: e({ name: "MYT", setup() {
  return () => r(Er);
} }), mexico: e({ name: "mexico", setup() {
  return () => r(Kr);
} }), MEX: e({ name: "MEX", setup() {
  return () => r(Kr);
} }), micronesia: e({ name: "micronesia", setup() {
  return () => r(kr);
} }), FSM: e({ name: "FSM", setup() {
  return () => r(kr);
} }), moldova: e({ name: "moldova", setup() {
  return () => r(Ur);
} }), MDA: e({ name: "MDA", setup() {
  return () => r(Ur);
} }), monaco: e({ name: "monaco", setup() {
  return () => r(vr);
} }), MCO: e({ name: "MCO", setup() {
  return () => r(vr);
} }), mongolia: e({ name: "mongolia", setup() {
  return () => r(Or);
} }), MNG: e({ name: "MNG", setup() {
  return () => r(Or);
} }), montenegro: e({ name: "montenegro", setup() {
  return () => r(Pr);
} }), MNE: e({ name: "MNE", setup() {
  return () => r(Pr);
} }), montserrat: e({ name: "montserrat", setup() {
  return () => r(Dr);
} }), MSR: e({ name: "MSR", setup() {
  return () => r(Dr);
} }), morocco: e({ name: "morocco", setup() {
  return () => r(wr);
} }), MAR: e({ name: "MAR", setup() {
  return () => r(wr);
} }), mozambique: e({ name: "mozambique", setup() {
  return () => r(zr);
} }), MOZ: e({ name: "MOZ", setup() {
  return () => r(zr);
} }), myanmar: e({ name: "myanmar", setup() {
  return () => r(Hr);
} }), MMR: e({ name: "MMR", setup() {
  return () => r(Hr);
} }), namibia: e({ name: "namibia", setup() {
  return () => r(Vr);
} }), NAM: e({ name: "NAM", setup() {
  return () => r(Vr);
} }), nauru: e({ name: "nauru", setup() {
  return () => r(Fr);
} }), NRU: e({ name: "NRU", setup() {
  return () => r(Fr);
} }), nepal: e({ name: "nepal", setup() {
  return () => r(Zr);
} }), NPL: e({ name: "NPL", setup() {
  return () => r(Zr);
} }), netherlands: e({ name: "netherlands", setup() {
  return () => r(Yr);
} }), NLD: e({ name: "NLD", setup() {
  return () => r(Yr);
} }), newCaledonia: e({ name: "newCaledonia", setup() {
  return () => r(Wr);
} }), NCL: e({ name: "NCL", setup() {
  return () => r(Wr);
} }), newZealand: e({ name: "newZealand", setup() {
  return () => r(jr);
} }), NZL: e({ name: "NZL", setup() {
  return () => r(jr);
} }), nicaragua: e({ name: "nicaragua", setup() {
  return () => r(Jr);
} }), NIC: e({ name: "NIC", setup() {
  return () => r(Jr);
} }), nigeria: e({ name: "nigeria", setup() {
  return () => r(qr);
} }), NGA: e({ name: "NGA", setup() {
  return () => r(qr);
} }), niger: e({ name: "niger", setup() {
  return () => r(Qr);
} }), NER: e({ name: "NER", setup() {
  return () => r(Qr);
} }), niue: e({ name: "niue", setup() {
  return () => r(xr);
} }), NIU: e({ name: "NIU", setup() {
  return () => r(xr);
} }), norfolkIsland: e({ name: "norfolkIsland", setup() {
  return () => r(Xr);
} }), NFK: e({ name: "NFK", setup() {
  return () => r(Xr);
} }), northKorea: e({ name: "northKorea", setup() {
  return () => r(_r);
} }), PRK: e({ name: "PRK", setup() {
  return () => r(_r);
} }), norway: e({ name: "norway", setup() {
  return () => r($r);
} }), NOR: e({ name: "NOR", setup() {
  return () => r($r);
} }), oman: e({ name: "oman", setup() {
  return () => r(en);
} }), OMN: e({ name: "OMN", setup() {
  return () => r(en);
} }), pakistan: e({ name: "pakistan", setup() {
  return () => r(rn);
} }), PAK: e({ name: "PAK", setup() {
  return () => r(rn);
} }), palau: e({ name: "palau", setup() {
  return () => r(nn);
} }), PLW: e({ name: "PLW", setup() {
  return () => r(nn);
} }), palestineState: e({ name: "palestineState", setup() {
  return () => r(an);
} }), PSE: e({ name: "PSE", setup() {
  return () => r(an);
} }), panama: e({ name: "panama", setup() {
  return () => r(tn);
} }), PAN: e({ name: "PAN", setup() {
  return () => r(tn);
} }), papuaNewGuinea: e({ name: "papuaNewGuinea", setup() {
  return () => r(un);
} }), PNG: e({ name: "PNG", setup() {
  return () => r(un);
} }), paraguay: e({ name: "paraguay", setup() {
  return () => r(mn);
} }), PRY: e({ name: "PRY", setup() {
  return () => r(mn);
} }), peru: e({ name: "peru", setup() {
  return () => r(sn);
} }), PER: e({ name: "PER", setup() {
  return () => r(sn);
} }), philippines: e({ name: "philippines", setup() {
  return () => r(on);
} }), PHL: e({ name: "PHL", setup() {
  return () => r(on);
} }), poland: e({ name: "poland", setup() {
  return () => r(pn);
} }), POL: e({ name: "POL", setup() {
  return () => r(pn);
} }), portugal: e({ name: "portugal", setup() {
  return () => r(ln);
} }), PRT: e({ name: "PRT", setup() {
  return () => r(ln);
} }), puertoRico: e({ name: "puertoRico", setup() {
  return () => r(fn);
} }), PRI: e({ name: "PRI", setup() {
  return () => r(fn);
} }), qatar: e({ name: "qatar", setup() {
  return () => r(dn);
} }), QAT: e({ name: "QAT", setup() {
  return () => r(dn);
} }), republicOfMacedonia: e({ name: "republicOfMacedonia", setup() {
  return () => r(cn);
} }), MKD: e({ name: "MKD", setup() {
  return () => r(cn);
} }), reunion: e({ name: "reunion", setup() {
  return () => r(gn);
} }), REU: e({ name: "REU", setup() {
  return () => r(gn);
} }), romania: e({ name: "romania", setup() {
  return () => r(bn);
} }), ROU: e({ name: "ROU", setup() {
  return () => r(bn);
} }), russia: e({ name: "russia", setup() {
  return () => r(An);
} }), RUS: e({ name: "RUS", setup() {
  return () => r(An);
} }), rwanda: e({ name: "rwanda", setup() {
  return () => r(hn);
} }), RWA: e({ name: "RWA", setup() {
  return () => r(hn);
} }), saintBarthelemy: e({ name: "saintBarthelemy", setup() {
  return () => r(Mn);
} }), BLM: e({ name: "BLM", setup() {
  return () => r(Mn);
} }), saintHelenaAscensionAndTristanDaCunha: e({ name: "saintHelenaAscensionAndTristanDaCunha", setup() {
  return () => r(Rn);
} }), SNH: e({ name: "SNH", setup() {
  return () => r(Rn);
} }), saintKittsAndNevis: e({ name: "saintKittsAndNevis", setup() {
  return () => r(In);
} }), KNA: e({ name: "KNA", setup() {
  return () => r(In);
} }), saintMartinFrenchPart: e({ name: "saintMartinFrenchPart", setup() {
  return () => r(Sn);
} }), MAF: e({ name: "MAF", setup() {
  return () => r(Sn);
} }), saintPierreAndMiquelon: e({ name: "saintPierreAndMiquelon", setup() {
  return () => r(Nn);
} }), SPM: e({ name: "SPM", setup() {
  return () => r(Nn);
} }), samoa: e({ name: "samoa", setup() {
  return () => r(Tn);
} }), WSM: e({ name: "WSM", setup() {
  return () => r(Tn);
} }), sanMarino: e({ name: "sanMarino", setup() {
  return () => r(Gn);
} }), SMR: e({ name: "SMR", setup() {
  return () => r(Gn);
} }), saoTomeAndPrince: e({ name: "saoTomeAndPrince", setup() {
  return () => r(Ln);
} }), STP: e({ name: "STP", setup() {
  return () => r(Ln);
} }), saudiArabia: e({ name: "saudiArabia", setup() {
  return () => r(Bn);
} }), SAU: e({ name: "SAU", setup() {
  return () => r(Bn);
} }), senegal: e({ name: "senegal", setup() {
  return () => r(yn);
} }), SEN: e({ name: "SEN", setup() {
  return () => r(yn);
} }), serbia: e({ name: "serbia", setup() {
  return () => r(Cn);
} }), SRB: e({ name: "SRB", setup() {
  return () => r(Cn);
} }), seychelles: e({ name: "seychelles", setup() {
  return () => r(En);
} }), SYC: e({ name: "SYC", setup() {
  return () => r(En);
} }), sierraLeone: e({ name: "sierraLeone", setup() {
  return () => r(Kn);
} }), SLE: e({ name: "SLE", setup() {
  return () => r(Kn);
} }), singapore: e({ name: "singapore", setup() {
  return () => r(kn);
} }), SGP: e({ name: "SGP", setup() {
  return () => r(kn);
} }), slovakia: e({ name: "slovakia", setup() {
  return () => r(Un);
} }), SVK: e({ name: "SVK", setup() {
  return () => r(Un);
} }), slovenia: e({ name: "slovenia", setup() {
  return () => r(vn);
} }), SVN: e({ name: "SVN", setup() {
  return () => r(vn);
} }), solomonIslands: e({ name: "solomonIslands", setup() {
  return () => r(On);
} }), SLB: e({ name: "SLB", setup() {
  return () => r(On);
} }), somalia: e({ name: "somalia", setup() {
  return () => r(Pn);
} }), SOM: e({ name: "SOM", setup() {
  return () => r(Pn);
} }), southAfrica: e({ name: "southAfrica", setup() {
  return () => r(Dn);
} }), ZAF: e({ name: "ZAF", setup() {
  return () => r(Dn);
} }), southGeorgiaAndTheSouthSandwichIslands: e({ name: "southGeorgiaAndTheSouthSandwichIslands", setup() {
  return () => r(wn);
} }), SGS: e({ name: "SGS", setup() {
  return () => r(wn);
} }), southKorea: e({ name: "southKorea", setup() {
  return () => r(zn);
} }), KOR: e({ name: "KOR", setup() {
  return () => r(zn);
} }), southSudan: e({ name: "southSudan", setup() {
  return () => r(Hn);
} }), SSD: e({ name: "SSD", setup() {
  return () => r(Hn);
} }), spain: e({ name: "spain", setup() {
  return () => r(Vn);
} }), ESP: e({ name: "ESP", setup() {
  return () => r(Vn);
} }), sriLanka: e({ name: "sriLanka", setup() {
  return () => r(Fn);
} }), LKA: e({ name: "LKA", setup() {
  return () => r(Fn);
} }), stLucia: e({ name: "stLucia", setup() {
  return () => r(Zn);
} }), LCA: e({ name: "LCA", setup() {
  return () => r(Zn);
} }), stVincentAndTheGrenadines: e({ name: "stVincentAndTheGrenadines", setup() {
  return () => r(Yn);
} }), VCT: e({ name: "VCT", setup() {
  return () => r(Yn);
} }), sudan: e({ name: "sudan", setup() {
  return () => r(Wn);
} }), SDN: e({ name: "SDN", setup() {
  return () => r(Wn);
} }), suriname: e({ name: "suriname", setup() {
  return () => r(jn);
} }), SUR: e({ name: "SUR", setup() {
  return () => r(jn);
} }), svalbardAndJanMayen: e({ name: "svalbardAndJanMayen", setup() {
  return () => r(Jn);
} }), SJM: e({ name: "SJM", setup() {
  return () => r(Jn);
} }), swaziland: e({ name: "swaziland", setup() {
  return () => r(qn);
} }), SWZ: e({ name: "SWZ", setup() {
  return () => r(qn);
} }), sweden: e({ name: "sweden", setup() {
  return () => r(Qn);
} }), SWE: e({ name: "SWE", setup() {
  return () => r(Qn);
} }), switzerland: e({ name: "switzerland", setup() {
  return () => r(xn);
} }), CHE: e({ name: "CHE", setup() {
  return () => r(xn);
} }), syria: e({ name: "syria", setup() {
  return () => r(Xn);
} }), SYR: e({ name: "SYR", setup() {
  return () => r(Xn);
} }), taiwan: e({ name: "taiwan", setup() {
  return () => r(_n);
} }), TWN: e({ name: "TWN", setup() {
  return () => r(_n);
} }), tajikistan: e({ name: "tajikistan", setup() {
  return () => r($n);
} }), TJK: e({ name: "TJK", setup() {
  return () => r($n);
} }), tanzania: e({ name: "tanzania", setup() {
  return () => r(ea);
} }), TZA: e({ name: "TZA", setup() {
  return () => r(ea);
} }), thailand: e({ name: "thailand", setup() {
  return () => r(ra);
} }), THA: e({ name: "THA", setup() {
  return () => r(ra);
} }), togo: e({ name: "togo", setup() {
  return () => r(na);
} }), TGO: e({ name: "TGO", setup() {
  return () => r(na);
} }), tokelau: e({ name: "tokelau", setup() {
  return () => r(aa);
} }), TKL: e({ name: "TKL", setup() {
  return () => r(aa);
} }), tonga: e({ name: "tonga", setup() {
  return () => r(ta);
} }), TON: e({ name: "TON", setup() {
  return () => r(ta);
} }), trinidadAndTobago: e({ name: "trinidadAndTobago", setup() {
  return () => r(ua);
} }), TTO: e({ name: "TTO", setup() {
  return () => r(ua);
} }), tunisia: e({ name: "tunisia", setup() {
  return () => r(ma);
} }), TUN: e({ name: "TUN", setup() {
  return () => r(ma);
} }), turkey: e({ name: "turkey", setup() {
  return () => r(sa);
} }), TUR: e({ name: "TUR", setup() {
  return () => r(sa);
} }), turkmenistan: e({ name: "turkmenistan", setup() {
  return () => r(oa);
} }), TKM: e({ name: "TKM", setup() {
  return () => r(oa);
} }), turksAndCaicosIslands: e({ name: "turksAndCaicosIslands", setup() {
  return () => r(ia);
} }), TCA: e({ name: "TCA", setup() {
  return () => r(ia);
} }), tuvalu: e({ name: "tuvalu", setup() {
  return () => r(pa);
} }), TUV: e({ name: "TUV", setup() {
  return () => r(pa);
} }), uganda: e({ name: "uganda", setup() {
  return () => r(la);
} }), UGA: e({ name: "UGA", setup() {
  return () => r(la);
} }), ukraine: e({ name: "ukraine", setup() {
  return () => r(fa);
} }), UKR: e({ name: "UKR", setup() {
  return () => r(fa);
} }), unitedArabEmirates: e({ name: "unitedArabEmirates", setup() {
  return () => r(da);
} }), ARE: e({ name: "ARE", setup() {
  return () => r(da);
} }), unitedKingdom: e({ name: "unitedKingdom", setup() {
  return () => r(ca);
} }), GBR: e({ name: "GBR", setup() {
  return () => r(ca);
} }), unitedStates: e({ name: "unitedStates", setup() {
  return () => r(ga);
} }), USA: e({ name: "USA", setup() {
  return () => r(ga);
} }), uruguay: e({ name: "uruguay", setup() {
  return () => r(ba);
} }), URY: e({ name: "URY", setup() {
  return () => r(ba);
} }), uzbekistan: e({ name: "uzbekistan", setup() {
  return () => r(Aa);
} }), UZB: e({ name: "UZB", setup() {
  return () => r(Aa);
} }), vanuatu: e({ name: "vanuatu", setup() {
  return () => r(ha);
} }), VUT: e({ name: "VUT", setup() {
  return () => r(ha);
} }), vaticanCity: e({ name: "vaticanCity", setup() {
  return () => r(Ma);
} }), VAT: e({ name: "VAT", setup() {
  return () => r(Ma);
} }), venezuela: e({ name: "venezuela", setup() {
  return () => r(Ra);
} }), VEN: e({ name: "VEN", setup() {
  return () => r(Ra);
} }), vietnam: e({ name: "vietnam", setup() {
  return () => r(Ia);
} }), VNM: e({ name: "VNM", setup() {
  return () => r(Ia);
} }), virginIslandsBritish: e({ name: "virginIslandsBritish", setup() {
  return () => r(Sa);
} }), VGB: e({ name: "VGB", setup() {
  return () => r(Sa);
} }), virginIslandsUs: e({ name: "virginIslandsUs", setup() {
  return () => r(Na);
} }), VIR: e({ name: "VIR", setup() {
  return () => r(Na);
} }), wallisAndFutuna: e({ name: "wallisAndFutuna", setup() {
  return () => r(Ta);
} }), WLF: e({ name: "WLF", setup() {
  return () => r(Ta);
} }), yemen: e({ name: "yemen", setup() {
  return () => r(Ga);
} }), YEM: e({ name: "YEM", setup() {
  return () => r(Ga);
} }), zambia: e({ name: "zambia", setup() {
  return () => r(La);
} }), ZMB: e({ name: "ZMB", setup() {
  return () => r(La);
} }), zimbabwe: e({ name: "zimbabwe", setup() {
  return () => r(Ba);
} }), ZWE: e({ name: "ZWE", setup() {
  return () => r(Ba);
} }) };
export {
  eo as flags
};
